<template>
  <div class="main grid">
    <h1
      class="bg-gray-700 rounded-t-md px-6 py-10 text-white text-3xl sm:text-5xl font-bold text-center tracking-wider"
    >
      Grab This Exclusive Offer Now!
    </h1>
    <div class="bg-gray-100 w-full grid justify-center pt-10 pb-8">
      <div class="flex gap-3 text-3xl font-bold text-white">
        <div class="bg-red-700 rounded-md p-3 timer__days hidden">00</div>
        <div class="bg-red-700 rounded-md p-3 timer__hours">00</div>
        <div class="bg-red-700 rounded-md p-3 timer__minutes">00</div>
        <div class="bg-red-700 rounded-md p-3 timer__seconds">00</div>
      </div>
    </div>
    <h2
      class="bg-gray-100 text-center tracking-wide font-bold text-5xl px-6 pb-10"
    >
      Want to be discrete ... even if you think you can't?
    </h2>
    <div class="sim-slider bg-white relative border-2 border-gray-100 rounded-b-md">
      <ul class="sim-slider-list m-0 p-0 relative list-none">
        <li
          class="sim-slider-element absolute w-full opacity-0 z-10 left-0 top-0 block transition duration-1000 ease-in-out"
        >
          <img src="@/assets/images/slide1.jpg" alt="1" />
        </li>
        <li
          class="sim-slider-element absolute w-full opacity-0 z-10 left-0 top-0 block transition duration-1000 ease-in-out"
        >
          <img src="@/assets/images/slide3.jpg" alt="2" />
        </li>
        <li
          class="sim-slider-element absolute w-full opacity-0 z-10 left-0 top-0 block transition duration-1000 ease-in-out"
        >
          <img src="@/assets/images/slide22.jpg" alt="1" />
        </li>
        <li
          class="sim-slider-element w-full opacity-0 z-10 left-0 top-0 block ease-in-out transition duration-1000 ease-in-out"
        >
          <img src="@/assets/images/slide4.jpg" alt="2" />
        </li>
      </ul>
    </div>
    <div class="font-bold grid justify-center">
      <img src="@/assets/images/sale.jpg" alt="Sale" class="mb-6">
      <p class="text-xl text-center font-medium text-red-600 ">FREE? EXPRESS SHIPPING</p>
      <p class="text-xl text-center pt-1 pb-8 font-medium text-red-600">
        (RETAIL PRICE 1997$)
      </p>
      <h3
        class="text-center p-6 border-2 border-dashed border-red-600 text-red-600 rounded-md tracking-wide font-bold text-3xl"
      >
        Protect your personal privacy now!
      </h3>
    </div>
    <div class="font-bold py-12 rounded-b-md flex justify-center">
      <a
        href="/order.html"
        class="transition duration-500 ease-in-out bg-red-600 hover:bg-blue-500 transform hover:-translate-y-1 hover:scale-110 rounded-md text-white tracking-wide text-3xl text-center font-medium py-5 w-full px-0 sm:px-20 sm:w-auto"
      >
        I want to buy!
      </a>
    </div>
  </div>
  <div class="description mt-6 mb-8 lg:px-0">
    <ul>
      <li class="mb-4">
        <div class="flex">
          <img src="@/assets/images/cul.png" class="h-6 mr-2" alt="Like" />
          <h4 class="text-xl font-medium">Discreet and professional</h4>
        </div>
        <p class="py-1">
          No one will ever know you're using a bug detector. Bug detector checks
          for all types of bugs and transmitters, so you can detect them without
          the person you're investigating knowing.
        </p>
      </li>
      <li class="mb-4">
        <div class="flex">
          <img src="@/assets/images/cul.png" class="h-6 mr-2" alt="Like" />
          <h4 class="text-xl font-medium">Protect your private life</h4>
        </div>
        <p class="py-1">
          Bug detectors can also be used to protect your private life, by
          checking for hidden transmitters in your home or office.
        </p>
      </li>
      <li class="mb-4">
        <div class="flex">
          <img src="@/assets/images/cul.png" class="h-6 mr-2" alt="Like" />
          <h4 class="text-xl font-medium">Detect any device invisibly</h4>
        </div>
        <p class="py-1">
          BUG DETECTOR The CSR6105 is a broadband receiver that detects bugs in
          the 2.4GHz to 5.8GHz frequency range, including Wi-Fi devices,
          Bluetooth devices, smartphones, tablets, baby monitors, wireless
          keyboards/mice/speakers/headphones etc.
        </p>
      </li>
      <li class="mb-4">
        <div class="flex">
          <img src="@/assets/images/cul.png" class="h-6 mr-2" alt="Like" />
          <h4 class="text-xl font-medium">Professional Bug Detection</h4>
        </div>
        <p class="py-1">
          We've got all your needs covered, from audio to video surveillance.
          With our wide range of detection equipment, we're sure to have the
          perfect bug detector for you. The CSR6105 is a broadband receiver
          designed to detect and locate all major types of electronic
          surveillance devices including:
        </p>
        <ul class="ml-4">
          <li class="list-disc py-1">Room Transmitters</li>
          <li class="list-disc py-1">Telephone Transmitters</li>
          <li class="list-disc py-1">Body Bugs</li>
          <li class="list-disc py-1">Video Transmitters</li>
        </ul>
        <p class="py-1">
          Broadband receivers such as the Bug Detector CSR6105 provide a very
          important cost-effective tool for professional sweep teams, government
          security personal and private citizens with important security needs.
        </p>
      </li>
    </ul>
    <div class="slider overflow-hidden">
      <div class="slider__wrapper">
        <div class="slider__items">
          <div class="slider__item">
            <img
              src="@/assets/images/bud-tedector-with-all-box.jpg"
              alt="bud-tedector-with-all-box"
            />
          </div>
          <div class="slider__item">
            <img src="@/assets/images/box-inside1.jpg" alt="box-inside" />
          </div>
          <div class="slider__item">
            <img
              src="@/assets/images/budetector-box.jpg"
              alt="budetector-box"
            />
          </div>
        </div>
      </div>
      <!-- Кнопки -->
      <a href="#" class="slider__control" data-slide="prev"></a>
      <a href="#" class="slider__control" data-slide="next"></a>
    </div>
    <div class="specification">
      <h3 class="text-center text-2xl font-bold my-12">
        Technical specification
      </h3>
      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        Frequency Ranges
      </h5>
      <div class="flex items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-16">VLF Band</p>
        <span class="font-normal ml-8">20-400 KHz</span>
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-16">RF Band</p>
        <span class="font-normal ml-8">400 KHz – 8 GHz</span>
      </div>
      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        VLF Probe
      </h5>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-28">
          Frequency Bands
        </p>
        <span class="font-normal ml-8">20-400 KHz</span>
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-28">
          Sensitivity
        </p>
        <span class="font-normal ml-8">-35 dBm</span>
      </div>
      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        RF Probes
      </h5>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Frequency Response
        </p>
        <span class="font-normal ml-8">400KHz – 3 GHz / 1.5 – 8 GHz</span>
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Gain
        </p>
        <span class="font-normal ml-8">40 dB Center Range</span>
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Sensitivity
        </p>
        <span class="font-normal ml-8">-50 dBm</span>
      </div>
      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        Audio Amplifier
      </h5>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Frequency Response
        </p>
        <span class="font-normal ml-8">50 Hz – 16 KHz</span>
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Dynamic Range
        </p>
        <span class="font-normal ml-8">80 dB</span>
      </div>
      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        Display
      </h5>
      <div class="flex my-2 text-gray-600 font-medium text-sm">
          <p class="ml-6 w-20">LCD</p>
          <span class="text-gray-600 text-sm font-normal ml-8"
            >Blue Backlight <br />2 Lines x 16 Chars</span
          >
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-20">
          Alert Output
        </p>
        <span class="font-normal ml-8">5% – 80%</span>
      </div>

      <h5
        class="italic text-xl font-medium mb-2 py-2 px-6 bg-gray-100 rounded-sm"
      >
        Battery
      </h5>
      <div class="flex my-2 text-gray-600 font-medium text-sm">
        <p class="ml-6 w-36">Type</p>
        <span class="text-gray-600 text-sm font-normal ml-8"
          >6 x AA Alkaline – Life 10-16 Hr <br />Optional NiMH 1800 mAH</span
        >
      </div>
      <div class="flex my-2 items-center text-gray-600 font-medium text-sm">
        <p class="my-2 ml-6 w-36">
          Low Battery Indicator
        </p>
        <span class="font-normal ml-8">7.2V</span>
      </div>
    </div>
    <div class="comment">
      <h3 class="px-6 text-center text-2xl font-bold my-12">
        Read other people's stories below....
      </h3>
      <div class="mb-8 p-6 rounded-md border border-yellow-200 bg-yellow-50">
        <div class="flex mb-4">
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
        </div>
        <h6 class="font-medium pb-1 text-lg">
          Definitely works and will give you peace of mind.
        </h6>
        <p class="text-gray-600">
          This product is being used on a constant basis for countering illegal
          surveillance and tracking. There are individuals in our society who do
          not know or do not care when they violate individual constitutional
          rights.
        </p>
      </div>
      <div class="mb-8 p-6 rounded-md border border-yellow-200 bg-yellow-50">
        <div class="flex mb-4">
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
        </div>
        <h6 class="font-medium pb-1 text-lg">Actually works!</h6>
        <p class="text-gray-600">
          Recommend, this item actually works unlike some of the other ones I
          have tried.
        </p>
      </div>
      <div class="mb-8 p-6 rounded-md border border-yellow-200 bg-yellow-50">
        <div class="flex mb-4">
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
        </div>
        <h6 class="font-medium pb-1 text-lg">No more creeps</h6>
        <p class="text-gray-600">
          Love this thing. Once I got it dialed in properly, it picked up on
          several of my devices I hid around the house. No need to worry about
          any creeps while I have contractors in and out of my house. Would
          definitely buy again.
        </p>
      </div>
      <div class="mb-8 p-6 rounded-md border border-yellow-200 bg-yellow-50">
        <div class="flex mb-4">
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
        </div>
        <h6 class="font-medium pb-1 text-lg">Professional</h6>
        <p class="text-gray-600">
          More than what I expected. Complete confidence in privacy now.
        </p>
      </div>
      <div class="mb-8 p-6 rounded-md border border-yellow-200 bg-yellow-50">
        <div class="flex mb-4">
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
          <img src="@/assets/images/star.svg" width="20" alt="star" />
        </div>
        <h6 class="font-medium pb-1 text-lg">Excellent quality, ease of use</h6>
        <p class="text-gray-600">
          This product is being used on a constant basis for countering illegal
          surveillance and tracking. There are individuals in our society who do
          not know or do not care when they violate individual constitutional
          rights. One device has already been captured and the individual or
          group must think about that all the time. They are too stupid to
          realize the device leaves a retraceable footprint right back to them.
        </p>
      </div>
    </div>
    <h3
      class="text-red-700 font-bold text-5xl tracking-wider w-full text-center my-12"
    >
      Limited Time Offer!
    </h3>
    <img
      src="@/assets/images/slide1.jpg"
      alt="Bug detector"
      class="border-2 border-gray-100 rounded-t-md"
    />
    <div class="bg-gray-100 font-bold grid justify-center">
      <p class="text-xl text-center px-6 pt-8">
        Get professional bug detector and locator
      </p>
      <p class="text-xl text-center px-6 pt-1 pb-8">FOR 1397$ONLY +</p>
      <p class="text-xl text-center px-6 font-medium">FREE EXPRESS SHIPPING</p>
      <p class="text-xl text-center px-6 pt-1 pb-8 font-medium">
        (RETAIL PRICE 1997$)
      </p>
      <h3
        class="text-center p-6 border-2 border-dashed border-red-600 text-red-600 rounded-md tracking-wide font-bold text-3xl mx-6"
      >
        Protect your personal privacy now!
      </h3>
    </div>
    <div class="bg-gray-100 font-bold py-12 rounded-b-md flex justify-center">
      <a
        href="/order.html"
        class="text-center transition duration-500 ease-in-out bg-red-600 hover:bg-blue-500 transform hover:-translate-y-1 hover:scale-110 rounded-md text-white tracking-wide text-3xl font-medium py-5 w-full px-0 sm:px-20 sm:w-auto mx-6 sm:mx-0"
      >
        I want to buy!
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Main",
  created() {
    document.addEventListener("DOMContentLoaded", function () {
      const deadline = (function (y, m, d) {
        return new Date(y, m - 1, d);
      })(2025, 12, 25);

      let timerId = null;
      function countdownTimer() {
        const diff = deadline - new Date();
        if (diff <= 0) {
          clearInterval(timerId);
        }
        const days = diff > 0 ? Math.floor(diff / 1000 / 60 / 60 / 24) : 0;
        const hours = diff > 0 ? Math.floor(diff / 1000 / 60 / 60) % 24 : 0;
        const minutes = diff > 0 ? Math.floor(diff / 1000 / 60) % 60 : 0;
        const seconds = diff > 0 ? Math.floor(diff / 1000) % 60 : 0;
        $days.textContent = days < 10 ? "0" + days : days;
        $hours.textContent = hours < 10 ? "0" + hours : hours;
        $minutes.textContent = minutes < 10 ? "0" + minutes : minutes;
        $seconds.textContent = seconds < 10 ? "0" + seconds : seconds;
      }

      const $days = document.querySelector(".timer__days");
      const $hours = document.querySelector(".timer__hours");
      const $minutes = document.querySelector(".timer__minutes");
      const $seconds = document.querySelector(".timer__seconds");

      countdownTimer();

      timerId = setInterval(countdownTimer, 1000);
    });
  },
  mounted() {
    function Sim(sldrId) {
      let id = document.getElementById(sldrId);
      if (id) {
        this.sldrRoot = id;
      } else {
        this.sldrRoot = document.querySelector(".sim-slider");
      }

      this.sldrList = this.sldrRoot.querySelector(".sim-slider-list");
      this.sldrElements = this.sldrList.querySelectorAll(".sim-slider-element");
      this.sldrElemFirst = this.sldrList.querySelector(".sim-slider-element");

      this.options = Sim.defaults;
      Sim.initialize(this);
    }

    Sim.defaults = {
      loop: true,
      auto: true,
      interval: 6000,
    };

    Sim.prototype.elemPrev = function (num) {
      num = num || 1;

      let prevElement = this.currentElement;
      this.currentElement -= num;
      if (this.currentElement < 0) this.currentElement = this.elemCount - 1;

      this.sldrElements[this.currentElement].style.opacity = "1";
      this.sldrElements[prevElement].style.opacity = "0";
    };

    Sim.prototype.elemNext = function (num) {
      num = num || 1;

      let prevElement = this.currentElement;
      this.currentElement += num;
      if (this.currentElement >= this.elemCount) this.currentElement = 0;

      this.sldrElements[this.currentElement].style.opacity = "1";
      this.sldrElements[prevElement].style.opacity = "0";
    };

    Sim.initialize = function (that) {
      that.elemCount = that.sldrElements.length;
      that.currentElement = 0;
      let bgTime = getTime();

      function getTime() {
        return new Date().getTime();
      }
      function setAutoScroll() {
        that.autoScroll = setInterval(function () {
          let fnTime = getTime();
          if (fnTime - bgTime + 10 > that.options.interval) {
            bgTime = fnTime;
            that.elemNext();
          }
        }, that.options.interval);
      }

      if (that.elemCount <= 1) {
        that.options.auto = false;
      }
      if (that.elemCount >= 1) {
        that.sldrElemFirst.style.opacity = "1";
      }

      setAutoScroll();
    };
    new Sim();
  },
};
</script>

<style lang="scss">
.slider {
  position: relative;
}

.slider__container {
  overflow: hidden;
}

.slider__wrapper {
  /*overflow: hidden;*/
}

.slider__items {
  display: flex;
  transition: transform 0.5s ease;
}

.slider_disable-transition {
  transition: none;
}

.slider__item {
  flex: 0 0 100%;
  max-width: 100%;
  user-select: none;
}

/* кнопки влево и вправо */

.slider__control {
  position: absolute;
  top: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  color: #fff;
  text-align: center;
  height: 50px;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.2);
}

.slider__control_hide {
  display: none;
}

.slider__control[data-slide="prev"] {
  left: 0;
}

.slider__control[data-slide="next"] {
  right: 0;
}

.slider__control:hover,
.slider__control:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  background: rgba(0, 0, 0, 0.3);
}

.slider__control::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background: transparent no-repeat center center;
  background-size: 100% 100%;
}

.slider__control[data-slide="prev"]::before {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}

.slider__control[data-slide="next"]::before {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
}

/* индикаторы */

.slider__indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
  margin-top: 0;
  margin-bottom: 0;
}

.slider__indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 5px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: rgba(255, 255, 255, 0.5);
  background-clip: padding-box;
  border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
}

.slider__indicators li.active {
  background-color: rgba(255, 255, 255, 0.9);
}
</style>
